type Env = "production" | "development" | "test";

export const Environment = {
  production: {
    url: "https://piper-cloud-run-xefokvu6ea-ue.a.run.app",
    relyingParty: "piper.ldelosheros.com"
  },
  development: {
    url: "http://localhost:5001",
    relyingParty: "localhost"
  },
  test: {
    url: "http://localhost:5001",
    relyingParty: "localhost"
  }
}[(process.env.STAGE || process.env.NODE_ENV) as Env];
